module.exports = "/_next/static/images/3eaf344ddf3a8c4772556126bc2d1a35-choose-maturity-period.png.webp";